module.exports = __webpack_public_path__ + "static/media/dmz-standard.bc6a56fd.png";